import { TelemetryNav } from '@/components/landing/TelemetryNav';
import { TelemetryHero } from '@/components/landing/TelemetryHero';
import { TelemetryStrip } from '@/components/landing/TelemetryStatusBand';
import { MentalModelSection } from '@/components/landing/MentalModelSection';
import { SystemExplanation } from '@/components/landing/SystemExplanation';
import { AthletesExplanation } from '@/components/landing/AthletesExplanation';
import { CoachesSection } from '@/components/landing/sections/CoachesSection';
import { BrandSignatureSection } from '@/components/landing/sections/BrandSignatureSection';
import { TelemetryFooter } from '@/components/landing/TelemetryFooter';

const Landing = () => {
  return (
    <div className="min-h-[100svh] text-foreground overflow-x-hidden">
      <TelemetryNav />
      <TelemetryHero />
      
      {/* Telemetry strip breaks scroll flow */}
      <TelemetryStrip variant="default" />
      
      {/* Mental model - how the system thinks */}
      <MentalModelSection />
      
      {/* Second telemetry strip */}
      <TelemetryStrip variant="alt" />
      
      {/* System explanation with load management */}
      <SystemExplanation />
      
      {/* Athletes section with video */}
      <AthletesExplanation />
      
      {/* Coaches section with video */}
      <CoachesSection />
      
      {/* Brand signature - closing brand reinforcement */}
      <BrandSignatureSection />
      
      {/* Minimal footer */}
      <TelemetryFooter />
    </div>
  );
};

export default Landing;
